import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {useBrowserContext} from '../../../../libs/shared/ui/src/components/browser/browserContext';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Layer} from '../../../../libs/shared/ui/src/components/layers/layer';
import {EducationTipChrome} from '../../../../libs/shared/ui/src/components/tip/educationTipChrome';
import {
  InfoBubbleCloseButton,
  InfoBubbleCloseButtonVariantsEnum,
} from '../../../../libs/shared/ui/src/components/tip/infoBubbleCloseButton';
import {InfoBubbleContent} from '../../../../libs/shared/ui/src/components/tip/infoBubbleContent';
import {InfoBubbleDescription} from '../../../../libs/shared/ui/src/components/tip/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../../../../libs/shared/ui/src/components/tip/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../../../../libs/shared/ui/src/components/tip/infoBubbleFooterActions';
import {InfoBubbleHeroHeader} from '../../../../libs/shared/ui/src/components/tip/infoBubbleHeroHeader';
import {
  InfoBubblePill,
  InfoBubblePillVariantsEnum,
} from '../../../../libs/shared/ui/src/components/tip/infoBubblePill';
import ticketStatusesIdsAnnouncementTipImgSrc from '../../../assets/images/ticketStatusesIdsAnnouncementTip.png';
import {AppAnnouncementTipProps} from '../announcementTipHelpers';

/*
 * Props.
 */

interface TicketStatusesIdsAnnouncementTipProps extends AppAnnouncementTipProps {}

/*
 * Styles.
 */

// TODO: Standardize.
const StyledEducationTipChrome = styled(EducationTipChrome)`
  position: absolute;
  right: 16px;
  bottom: 16px;
`;

const StyledImg = styled.img`
  width: 100%;
`;

/*
 * Component.
 */

export const TicketStatusesIdsAnnouncementTip: FC<TicketStatusesIdsAnnouncementTipProps> = (props) => {
  const {openInBrowser} = useBrowserContext();

  const onCtaClick = () => {
    openInBrowser('https://help.front.com/en/categories/383040-ticketing');
    props.onCtaClickAfter();
  };

  return (
    <Layer>
      <StyledEducationTipChrome>
        <InfoBubbleHeroHeader>
          <StyledImg src={ticketStatusesIdsAnnouncementTipImgSrc} alt="" />
        </InfoBubbleHeroHeader>
        <InfoBubbleContent>
          <InfoBubblePill type={InfoBubblePillVariantsEnum.NEW_FEATURE} />
          <InfoBubbleTitle shouldWrapTitle>
            <Trans id="ticket-statuses-ids-announcement-title">Introducing ticket statuses and IDs</Trans>
          </InfoBubbleTitle>
          <InfoBubbleDescription>
            <Trans id="ticket-statuses-ids-announcement-description">
              Your team can now efficiently manage complex requests with granular statuses (open, waiting,
              resolved) and easily track conversations with unique ticket IDs.
            </Trans>
          </InfoBubbleDescription>
          <InfoBubbleFooterActions $justifyContentRight>
            <Button variant={ButtonVariantsEnum.PRIMARY} onClick={onCtaClick}>
              <Trans id="ticket-statuses-ids-announcement-cta">Get started</Trans>
            </Button>
          </InfoBubbleFooterActions>
        </InfoBubbleContent>
        <InfoBubbleCloseButton
          variant={InfoBubbleCloseButtonVariantsEnum.DARK_ON_LIGHT}
          onClose={props.onCloseClick}
        />
      </StyledEducationTipChrome>
    </Layer>
  );
};
